import request from '../../shared/request'

export function getAllHelp() {
  return request('/help')
}

export function createHelp(payload) {
  return request(`/help`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function editHelp(payload) {
  return request(`/help/${payload.helpId}`, {
    method: 'PUT',
    body: payload.content,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteHelp(payload) {
  return request(`/help/${payload.helpId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

//Attachment APIs
export function uploadAttachments(payload) {
  return request(`/help/${payload.helpId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(helpId) {
  return request(`/help/${helpId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/help/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/help/${payload.attachmentId}/attachment/?helpId=${payload.helpId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/help.js